import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { cleanList } from '../../commons/cleanList';

export function mapDocuments(
  input: DocumentsFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'Document'> {
  return {
    key: 'Document',
    input: {
      heading: input.title,
      items: input.documents?.filter(cleanList).map((doc) => ({
        title: doc.title,
        Link: buildLink({ href: doc.url }),
      })),
    },
  };
}
